import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WorkerProfileRoutingModule } from './worker-profile-routing.module';
import { WorkerProfileComponent } from './worker-profile/worker-profile.component';
import { WorkerProfileDetailComponent } from './worker-profile-detail/worker-profile-detail.component';
import { MaterialModule } from '../shared/material/material.module';
import { IwgcommonModule } from '../iwgcommon/iwgcommon.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppRoutingModule } from '../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedPipesModule } from '../shared/pipes/sharedpipes.module';
import {WorkerProfileService} from '../../app/shared/services/worker-profile.service'


@NgModule({
  declarations: [WorkerProfileComponent, WorkerProfileDetailComponent],
  imports: [
    CommonModule,
    MaterialModule,
    IwgcommonModule,
    FlexLayoutModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedPipesModule,
    WorkerProfileRoutingModule
  ],
  providers:[WorkerProfileService],
  exports:[WorkerProfileDetailComponent, WorkerProfileComponent]
})
export class WorkerProfileModule { }
